import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from '@reduxjs/toolkit';
import I18n from 'i18n-js';
import localForage from 'localforage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import { setApiLanguage } from '@lootboy/lib';
import { fetchConfigurationIfNeeded } from '@lootboy/lib/actions/ConfigurationActions';
import { setRadarApiUrl } from '@lootboy/lib/api/apiUrls';
import { setMaxNumberOfSearchHistoryEntries } from '@lootboy/lib/slices/searchHistory';
import { NOOP } from '@lootboy/lib/utils';

import config from '~/config';
import { loadTranslationAsynchronously } from '~/i18n';
import { cardFiltersName } from '~/redux/slices/cardFilters';

import observers from '../obesrvers';
import reducers from '../reducers';
import slices from '../slices';

const persistConfig = {
  key: 'lootboy',
  storage: localForage,
  blacklist: ['location', cardFiltersName],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({ ...reducers, ...slices }),
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default () => {
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk)),
  );

  const persistor = persistStore(store);

  const onBeforeLift = async () => {
    const state = store.getState();

    if (state.auth.token) {
      store.dispatch({
        type: 'SET_REDIRECT_ROUTE_AFTER_LOGIN',
        routeAfterLogin: '',
      });
    }

    if (
      typeof process.env.REACT_APP_API_URL === 'string' &&
      process.env.REACT_APP_API_URL.length > 0 &&
      (!state.auth ||
        !state.auth.apiUrl ||
        state.auth.apiUrl !== process.env.REACT_APP_API_URL)
    ) {
      store.dispatch({
        type: 'SET_API_URL',
        apiUrl: process.env.REACT_APP_API_URL,
        timestamp: Date.now(),
      });
    }

    if (
      typeof process.env.REACT_APP_RADAR_API_URL === 'string' &&
      process.env.REACT_APP_RADAR_API_URL.length > 0
    ) {
      setRadarApiUrl(process.env.REACT_APP_RADAR_API_URL);
    }

    // should be dispatched as early as possible to determine if radar is enabled
    store.dispatch(fetchConfigurationIfNeeded()).catch(NOOP);

    await loadTranslationAsynchronously(I18n.defaultLocale);
    if (state.auth.language) {
      await loadTranslationAsynchronously(state.auth.language);
      I18n.locale = state.auth.language;
      setApiLanguage(I18n.locale);
    }
    store.dispatch(
      setMaxNumberOfSearchHistoryEntries(
        config.MAX_NUMBER_OF_SEARCH_HISTORY_ENTRIES,
      ),
    );

    Object.values(observers).forEach((observer) => {
      observer(store);
    });
  };
  return {
    store,
    persistor,
    onBeforeLift,
  };
};
